module.exports = __webpack_public_path__ + "img/gruppi.92a30aff.png";